import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import DataTypes from "~data";

import { useAuthentication } from "../providers/AuthenticationProvider";

export function useCurrentTeamId(allowNull?: false): DataTypes["Teams"]["id"];
export function useCurrentTeamId(allowNull?: true): DataTypes["Teams"]["id"] | null;
export function useCurrentTeamId(allowNull: boolean = false): DataTypes["Teams"]["id"] | null {
  const { teams } = useAuthentication();
  const { pathname } = useLocation();
  if (!teams && !allowNull)
    throw new Error("You can only use useCurrentTeamId without allowing null on authenticated routes");

  const currentTeamId = useMemo(() => {
    return teams?.find((t) => pathname.split("/").includes(t.domain))?.id;
  }, [teams, pathname]);

  if (currentTeamId) return currentTeamId;

  if (allowNull) return null;

  throw new Error(
    "User is not member of the team, we are not allowing null, but the router allowed rendering this component",
  );
}
